// ============================================================
// Smaak dropdown — global handlers for PDP, quick view, and collection pages
// ============================================================

// 1. SCROLL GUARD — cleans stale overflow + blocks background scroll when quick view is open
(function() {
  if (window.__smaakScrollGuard) return;
  window.__smaakScrollGuard = true;

  // Clean stale overflow:hidden after drawers close
  new MutationObserver(function() {
    var popupOpen = document.querySelector('#smaakOverlaySheet.open');
    var sidebarOpen = document.body.classList.contains('scroll-y-off') || document.body.classList.contains('scroll-y-off-firefox');
    if (!popupOpen && !sidebarOpen && document.body.style.overflow === 'hidden') {
      document.body.style.removeProperty('overflow');
      document.documentElement.style.removeProperty('overflow');
    }
  }).observe(document.body, { attributes: true, attributeFilter: ['class', 'style'] });

  // Block scroll on background when quick view is open (mobile + desktop)
  function isInsideOverlay(el) {
    while (el && el !== document) {
      if (el.classList && (
        el.classList.contains('quick-view__body') ||
        el.classList.contains('product__info') ||
        el.classList.contains('bundle-variant-popup__sheet') ||
        el.classList.contains('bundle-variant-popup__scrim')
      )) return true;
      el = el.parentElement;
    }
    return false;
  }

  // Block background scroll when any overlay is open (mobile + desktop)
  function blockBackgroundScroll(e) {
    var hasOverlay = document.querySelector('.quick-view.is-opened') ||
                     document.querySelector('.bundle-variant-popup.is-active');
    if (!hasOverlay) return;
    if (isInsideOverlay(e.target)) return;
    e.preventDefault();
  }
  document.addEventListener('touchmove', blockBackgroundScroll, { passive: false });
  document.addEventListener('wheel', blockBackgroundScroll, { passive: false });
})();

// 2. VARIANT FILTERING + AUTO-SELECT + BEST DEAL — mirrors PDP logic exactly
(function() {
  if (window.__smaakQuickViewFiltering) return;
  window.__smaakQuickViewFiltering = true;

  var SMAAK_KEYWORDS = ['smaak', 'flavour', 'flavor', 'geschmack', 'kleur', 'color', 'farbe'];
  var SIZE_KEYWORDS = ['maat', 'size', 'größe', 'grosse'];

  function isSizeGroup(label) {
    var group = label.closest('[option-picker-name]');
    var groupName = group ? (group.getAttribute('option-picker-name') || '').toLowerCase() : '';
    return SIZE_KEYWORDS.some(function(k) { return groupName.indexOf(k) !== -1; });
  }
  function getSoldOutText(label) { return isSizeGroup(label) ? '✕' : 'SOLD OUT'; }
  function getSoldOutClass(label) { return 'sold-out-badge' + (isSizeGroup(label) ? ' sold-out-badge--x' : ''); }
  var _variantsCache = new WeakMap(); // Cache parsed JSON per picker

  function isSmaakLike(name) {
    var lower = (name || '').toLowerCase();
    return SMAAK_KEYWORDS.some(function(k) { return lower.indexOf(k) !== -1; });
  }

  function escapeId(id) {
    return typeof CSS !== 'undefined' && CSS.escape ? CSS.escape(id) : id.replace(/([:.\[\]])/g, '\\$1');
  }

  function findInput(label, picker) {
    var inp = label.querySelector('input');
    if (inp) return inp;
    var forId = label.getAttribute('for');
    if (forId) return picker.querySelector('#' + escapeId(forId));
    return null;
  }

  function getSelected(picker) {
    var sel = {};
    for (var pos = 1; pos <= 3; pos++) {
      var inp = picker.querySelector('input[type="radio"][name$="-' + pos + '"]:checked');
      if (inp) sel[pos] = inp.value;
    }
    return sel;
  }

  function getVariants(picker) {
    var cached = _variantsCache.get(picker);
    if (cached) return cached;
    var script = picker.querySelector('script[data-variant-picker-variants]');
    if (!script) return null;
    try {
      var v = JSON.parse(script.textContent || '[]');
      if (Array.isArray(v) && v.length) { _variantsCache.set(picker, v); return v; }
    } catch(e) {}
    return null;
  }

  // Main update function — mirrors PDP's updateGroup + autoSelectFirstAvailable + applyBestDealBadge
  function updateQuickViewPicker(picker, forceBest) {
    if (!picker || picker.getAttribute('data-update-url') === 'true') return;
    if (picker.dataset.smaakProcessing === 'true') return;
    picker.dataset.smaakProcessing = 'true';

    try {
      var variants = getVariants(picker);
      if (!variants) return;
      var smaakGroup = picker.querySelector('.smaak-variant');
      var smaakPosAttr = smaakGroup ? (smaakGroup.querySelector('[data-option-position]') || {}).getAttribute('data-option-position') : null;
      var smaakPos = smaakPosAttr ? parseInt(smaakPosAttr, 10) : null;
      var selected = getSelected(picker);
      var smaakValue = smaakPos ? selected[smaakPos] : null;

      // Get best-deal label from data attribute (translatable via Liquid).
      // Empty attribute means the feature is disabled (block setting blank or
      // product metafield custom.no_best_deal is true). Must match the PDP
      // inline script's behaviour in product-variant-picker-block.liquid, or
      // quick-view and PDP will disagree and the inline script's badge-strip
      // pass removes whatever this file added.
      var bestDealText = (picker.getAttribute('data-best-deal-label') || '').trim();

      // Pre-compute availability maps for O(1) lookups instead of O(n) per label
      var availByOption = {};
      var existsByCombo = {};
      var availByCombo = {};
      variants.forEach(function(v) {
        if (v.hideinshop === true) return;
        // A combo is only valid for the selected smaak when this variant's
        // own smaak option matches. Otherwise existsByCombo would claim every
        // secondary value exists for every smaak → nothing gets hidden.
        var matchesSelectedSmaak = !smaakPos || !smaakValue ||
          String(v['option' + smaakPos] || '') === String(smaakValue);
        for (var p = 1; p <= 3; p++) {
          var val = v['option' + p];
          if (!val) continue;
          var key = p + ':' + val;
          if (v.available) availByOption[key] = true;
          if (smaakPos && smaakValue && matchesSelectedSmaak) {
            var comboKey = p + ':' + val + '|' + smaakPos + ':' + smaakValue;
            existsByCombo[comboKey] = true;
            if (v.available) availByCombo[comboKey] = true;
          }
        }
      });

      // Smaak pills: grey out when ALL variants for that smaak are sold out
      // (applies to bundle AND standalone PDPs). Still clickable so Klaviyo
      // BIS can trigger on the sold-out selection.
      picker.querySelectorAll('.smaak-variant label[data-option-position]').forEach(function(label) {
        var val = label.getAttribute('data-option-value');
        var pos = parseInt(label.getAttribute('data-option-position'), 10);
        var inp = findInput(label, picker);
        var hasAvail = !!availByOption[pos + ':' + val];
        var oldSob = label.querySelector('.sold-out-badge');
        if (oldSob) oldSob.remove();
        if (hasAvail) {
          label.classList.remove('variant-unavailable');
          label.style.removeProperty('opacity');
          label.style.removeProperty('pointer-events');
          if (inp) inp.disabled = false;
        } else {
          label.classList.add('variant-unavailable');
          if (inp && inp.checked) label.classList.add('selected');
          else label.classList.remove('selected');
          label.style.setProperty('opacity', '0.5', 'important');
          label.style.setProperty('pointer-events', 'auto', 'important');
          if (inp) inp.disabled = false;
        }
      });

      var groupSelector = smaakGroup ? '.variant-option-group--secondary' : '.variant-option-group';
      picker.querySelectorAll(groupSelector).forEach(function(group) {
        if (isSmaakLike(group.getAttribute('option-picker-name'))) return;
        var _gNameQV = (group.getAttribute('option-picker-name') || '').toLowerCase();
        var _isSizeQV = SIZE_KEYWORDS.some(function(k) { return _gNameQV.indexOf(k) !== -1; });
        var labels = group.querySelectorAll('label[data-option-position]');
        if (!labels.length) return;
        var pos = parseInt(labels[0].getAttribute('data-option-position'), 10);
        if (!pos) return;

        // STEP 1: Filter labels
        labels.forEach(function(label) {
          var val = label.getAttribute('data-option-value');
          var input = findInput(label, picker);
          var comboKey = pos + ':' + val + '|' + smaakPos + ':' + smaakValue;
          var exists = (smaakPos && smaakValue) ?
            !!existsByCombo[comboKey] :
            !!availByOption[pos + ':' + val] || variants.some(function(v) { return v.hideinshop !== true && String(v['option' + pos] || '') === String(val); });

          var oldSobSec = label.querySelector('.sold-out-badge');
          if (oldSobSec) oldSobSec.remove();

          if (!exists) {
            label.style.display = 'none';
            label.classList.remove('variant-unavailable');
            if (input) input.disabled = true;
          } else {
            label.style.display = '';
            var avail = (smaakPos && smaakValue) ?
              !!availByCombo[comboKey] :
              !!availByOption[pos + ':' + val];
            if (avail) {
              label.classList.remove('variant-unavailable');
              // Clear any stale inline opacity left behind by a previous
              // sold-out render so the pill returns to full opacity.
              label.style.removeProperty('opacity');
              if (input) input.disabled = false;
            } else {
              label.classList.add('variant-unavailable');
              if (input) input.disabled = false;
              // Keep 'selected' in sync with the checked radio so the
              // gold border follows a clicked sold-out pill.
              if (input && input.checked) label.classList.add('selected');
              else label.classList.remove('selected');
            }
          }
        });

        // STEP 2: Auto-select most expensive available
        var checkedLabel = null;
        labels.forEach(function(lbl) {
          var inp = findInput(lbl, picker);
          if (inp && inp.checked) checkedLabel = lbl;
        });
        // Preserve the user's current secondary across primary changes, but
        // only when it's actually purchasable for the new primary. Sold-out
        // pills stay visible (Klaviyo back-in-stock needs them clickable), so
        // we must check variant-unavailable, not just display.
        // On initial open (forceBest=false) a sold-out default is respected.
        var isVisible = checkedLabel && checkedLabel.style.display !== 'none';
        var isAvailable = isVisible && !checkedLabel.classList.contains('variant-unavailable');
        var preserve = isAvailable || (isVisible && !forceBest);

        if (!preserve) {
          var bestInput = null;
          var bestLabel = null;
          var bestVal = -1;
          labels.forEach(function(lbl) {
            if (lbl.style.display === 'none' || lbl.classList.contains('variant-unavailable')) return;
            var inp = findInput(lbl, picker);
            if (!inp) return;
            var text = (lbl.querySelector('.pill__label') || {}).textContent || '';
            var num = parseFloat(text.replace(/[^\d.,]/g, '').replace(',', '.'));
            if (!isNaN(num) && num > bestVal) { bestVal = num; bestInput = inp; bestLabel = lbl; }
            else if (isNaN(num) && !bestInput) { bestInput = inp; bestLabel = lbl; }
          });
          // Fallback: if no available variant, select first visible (even sold-out for Klaviyo)
          if (!bestInput) {
            labels.forEach(function(lbl) {
              if (bestInput) return;
              if (lbl.style.display === 'none') return;
              var inp = findInput(lbl, picker);
              if (inp) { bestInput = inp; bestLabel = lbl; }
            });
          }
          if (bestInput) {
            if (checkedLabel) checkedLabel.classList.remove('selected');
            bestInput.checked = true;
            bestLabel.classList.add('selected');
          }
        }

        // STEP 3: Best deal badge (skip size groups). Always mark the pill
        // that matches the overall largest inhoud across ALL variants —
        // even if it's sold out. No label when this flavor has no variant
        // at the overall max, or when the setting is empty.
        labels.forEach(function(l) {
          l.classList.remove('best-deal');
          var b = l.querySelector('.best-deal-badge');
          if (b) b.remove();
        });
        if (_isSizeQV || !bestDealText) return;
        var parseNum = function(s) { return parseFloat(String(s || '').replace(/[^\d.,]/g, '').replace(',', '.')); };
        var norm = function(s) { return String(s || '').trim().toLowerCase(); };
        var bestDealOverride = (picker.getAttribute('data-best-deal-override') || '').trim();
        var visible = [].filter.call(labels, function(l) { return l.style.display !== 'none'; });
        var dealLbl = null;
        if (bestDealOverride) {
          // Override: badge de variant uit het metafield (op getal of tekst).
          var ovNum = parseNum(bestDealOverride);
          visible.forEach(function(l) {
            var text = (l.querySelector('.pill__label') || {}).textContent || '';
            if (norm(text) === norm(bestDealOverride) || (!isNaN(ovNum) && parseNum(text) === ovNum)) dealLbl = l;
          });
        } else {
          // Automatisch: grootste inhoud over alle varianten.
          var distinct = new Set();
          var overallMax = -Infinity;
          variants.forEach(function(v) {
            if (v.hideinshop === true) return;
            var num = parseNum(v['option' + pos]);
            if (isNaN(num)) return;
            distinct.add(num);
            if (num > overallMax) overallMax = num;
          });
          if (distinct.size <= 1 || overallMax === -Infinity) return;
          visible.forEach(function(l) {
            var text = (l.querySelector('.pill__label') || {}).textContent || '';
            if (parseNum(text) === overallMax) dealLbl = l;
          });
        }
        if (dealLbl) {
          dealLbl.classList.add('best-deal');
          var badge = document.createElement('span');
          badge.className = 'best-deal-badge';
          badge.textContent = bestDealText;
          dealLbl.appendChild(badge);
        }
      });
    } finally {
      picker.dataset.smaakProcessing = 'false';
    }
  }

  // Sold-out pills are now clickable (for Klaviyo back-in-stock) — no click blocking needed

  // Disable theme's float-element for smaak in quick view
  function disableFloatElements() {
    document.querySelectorAll('variant-picker[data-update-url="false"] .smaak-variant float-element').forEach(function(fe) {
      if (fe.dataset.disabled) return;
      fe.dataset.disabled = 'true';
      fe.remove();
    });
  }

  // Detect if a change event is a smaak change (input may be outside .smaak-variant)
  function isSmaakChange(e, picker) {
    if (e.target.closest('.smaak-variant')) return true;
    var smaakGroup = picker.querySelector('.smaak-variant');
    if (!smaakGroup) return false;
    var smaakPosAttr = (smaakGroup.querySelector('[data-option-position]') || {}).getAttribute('data-option-position');
    if (!smaakPosAttr) return false;
    var inputName = e.target.name || '';
    return inputName.endsWith('-' + smaakPosAttr);
  }

  // Capture phase ONLY: runs BEFORE theme's handleVariantChange
  // Sets correct inhoud selection before theme reads checked inputs
  document.addEventListener('change', function(e) {
    if (!e.target.matches || !e.target.matches('input[type="radio"]')) return;
    var picker = e.target.closest('variant-picker');
    if (!picker || picker.getAttribute('data-update-url') !== 'false') return;
    if (picker.dataset.smaakProcessing === 'true') return;
    updateQuickViewPicker(picker, isSmaakChange(e, picker));
  }, true);

  // Re-execute inline scripts inside a freshly-cloned picker. cloneNode(true)
  // copies <script> nodes but does NOT run them, so the PDP initialisation
  // that wires up variant filtering never fires for quick-view-on-collection.
  function reExecuteInlineScripts(picker) {
    if (!picker || picker.dataset.scriptsRehydrated === 'true') return;
    picker.dataset.scriptsRehydrated = 'true';
    // Clear the init guard so the script actually sets up this picker
    picker.removeAttribute('data-dropdown-init');
    var scripts = picker.querySelectorAll('script');
    scripts.forEach(function(old) {
      // Skip JSON data scripts — only re-run executable JS
      var type = (old.getAttribute('type') || '').toLowerCase();
      if (type === 'application/json' || old.hasAttribute('data-variant-picker-variants')) return;
      var fresh = document.createElement('script');
      if (old.src) fresh.src = old.src;
      else fresh.textContent = old.textContent;
      old.parentNode.replaceChild(fresh, old);
    });
  }

  // Process quick-view pickers — scoped to ACTIVE quick-view only.
  // Listing pages render hidden source-templates (one per product card) AND
  // the active <quick-view> dialog clones one of them when opened. Without
  // scoping, this function iterates over 20+ hidden templates per call,
  // doing variant-filtering + DOM mutations on each — 3+ seconds of forced
  // reflow per quick-view open on collection pages. Scope to dialog only.
  function processAllQuickViewPickers(forceBest) {
    var pickers = document.querySelectorAll(
      'quick-view.is-opened variant-picker[data-update-url="false"], ' +
      'sidebar-component.is-opened variant-picker[data-update-url="false"], ' +
      'dialog-component.is-opened variant-picker[data-update-url="false"]'
    );
    pickers.forEach(function(picker) {
      reExecuteInlineScripts(picker);
      disableFloatElements();
      // Reset the processing lock so the update actually fires
      picker.dataset.smaakProcessing = 'false';
      updateQuickViewPicker(picker, forceBest !== false);
    });
  }

  // Watch for dynamically loaded quick-view pickers (new nodes + attribute changes)
  new MutationObserver(function(mutations) {
    var shouldProcess = false;
    mutations.forEach(function(m) {
      // Added nodes — new pickers inserted (e.g. quick-view template cloned into DOM)
      if (m.type === 'childList') {
        m.addedNodes.forEach(function(node) {
          if (node.nodeType !== 1) return;
          var pickers = [];
          if (node.tagName === 'VARIANT-PICKER') pickers = [node];
          else if (node.querySelectorAll) pickers = node.querySelectorAll('variant-picker[data-update-url="false"]');
          if (pickers.length) shouldProcess = true;
        });
      }
      // is-opened toggled on a sidebar/quick-view → process pickers inside
      if (m.type === 'attributes' && m.attributeName === 'class') {
        var t = m.target;
        if (t && t.classList && t.classList.contains('is-opened')) shouldProcess = true;
      }
    });
    if (shouldProcess) {
      // One immediate rAF pass + one fallback after the open-animation
      // typically settles. Avoids 3 redundant DOM scans per quick-view open.
      requestAnimationFrame(function() { processAllQuickViewPickers(true); });
      setTimeout(function() { processAllQuickViewPickers(true); }, 400);
    }
  }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });

  // Also run once on DOMContentLoaded to catch server-rendered quick views
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { processAllQuickViewPickers(true); });
  } else {
    setTimeout(function() { processAllQuickViewPickers(true); }, 100);
  }
})();

// 3. QUICK VIEW DROPDOWN AUTO-SCROLL — watches for dropdown open/close in quick views
(function() {
  if (window.__qvDropdownScrollObserver) return;
  window.__qvDropdownScrollObserver = true;

  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(m) {
      if (m.type !== 'attributes' || m.attributeName !== 'data-dropdown-open') return;
      var optionGroup = m.target;
      if (!optionGroup.classList.contains('variant-option-group')) return;
      var qvC = optionGroup.closest('[data-quick-view-content]');
      if (!qvC) return;

      // De open dropdown moet volledig binnen de drawer vallen. Hij hangt
      // absoluut onder het keuzeveld, dus daarvoor moet de drawer meescrollen —
      // en daarvoor moet er onderaan iets te scrollen ZIJN.
      //
      // Hier ging het twee keer mis:
      //
      // 1. De extra ruimte stond als padding op [data-quick-view-content].
      //    Vanaf 768px zet bundle.css die container op `background: transparent`
      //    en komt het wit van de drawer uit .product__info-wrapper. Die strook
      //    viel dus buiten het witte paneel: je keek er dwars doorheen op de
      //    pagina erachter, alsof de onderkant van de drawer verdween.
      //
      // 2. Padding alleen is niet genoeg. .product__info-wrapper heeft
      //    `min-height: 100%`, dus bij een product dat korter is dan de drawer
      //    (Whey Protein: beeld + info samen ruim onder de drawerhoogte) blijft
      //    het paneel gewoon op die minimumhoogte staan zolang inhoud + padding
      //    daar niet overheen komen. De scrollhoogte groeide dan niet en de
      //    scroll deed niets — de dropdown liep onderaan gewoon door.
      //
      // Daarom nu de minimumhoogte zelf oprekken: `calc(100% + Npx)` geeft
      // gegarandeerd N pixels scrollruimte, ongeacht hoe lang het product is.
      // De padding op .product__info blijft ernaast staan voor het omgekeerde
      // geval — een product dat al langer is dan de drawer, waar de
      // minimumhoogte niets meer uitmaakt. Beide zitten binnen het witte
      // paneel, dus de drawer blijft tot onderaan dicht.
      var qvWrapper = optionGroup.closest('.product__info-wrapper');
      var qvInfo = optionGroup.closest('.product__info');

      // `important` op de padding omdat de mobiele regel in custom.css
      // `padding: ... !important` op .product__info zet.
      function qvAddRoom(extra) {
        if (qvWrapper) qvWrapper.style.setProperty('min-height', 'calc(100% + ' + extra + 'px)');
        if (qvInfo) qvInfo.style.setProperty('padding-bottom', extra + 'px', 'important');
        qvC.dataset.qvDropdownPadding = extra;
      }

      function qvClearRoom() {
        if (qvWrapper) qvWrapper.style.removeProperty('min-height');
        if (qvInfo) qvInfo.style.removeProperty('padding-bottom');
        delete qvC.dataset.qvDropdownPadding;
      }

      var isOpen = optionGroup.hasAttribute('data-dropdown-open');
      if (isOpen) {
        // Dropdown opened — maak scrollruimte, scroll mee, en top af als vangnet
        setTimeout(function() {
          var pillList = optionGroup.querySelector('.product-variant-picker__pill-list');
          if (!pillList) return;
          // Sluit de drawer terwijl de dropdown openstaat (Escape, klik op de
          // overlay), dan draait de opruimtak hieronder nooit en blijft de
          // ruimte staan. Bij hergebruik van hetzelfde paneel zou dat een gat
          // onder de toevoegknop opleveren, en zou de meting hieronder
          // bovendien op een al opgerekt paneel gebeuren.
          qvClearRoom();
          var overflow = pillList.getBoundingClientRect().bottom - qvC.getBoundingClientRect().bottom;
          if (overflow > 0) {
            qvAddRoom(overflow + 40);
            qvC.scrollBy({ top: overflow + 20, behavior: 'smooth' });
          }

          // Vangnet. Lukt het meescrollen niet — te weinig ruimte, een
          // onderbroken smooth scroll — dan mag de lijst nog steeds niet onder
          // de drawerrand doorlopen. In dat geval krijgt hij een maximumhoogte
          // en scrollt hij vanbinnen. De inline cssText die bij het openen op
          // deze lijst wordt gezet bevat geen max-height, en wordt bij het
          // sluiten volledig gewist, dus dit hoeft niet apart opgeruimd.
          setTimeout(function() {
            var listBottom = pillList.getBoundingClientRect().bottom;
            var containerBottom = qvC.getBoundingClientRect().bottom;
            if (listBottom <= containerBottom) return;
            var space = containerBottom - pillList.getBoundingClientRect().top - 12;
            pillList.style.setProperty('max-height', Math.max(120, space) + 'px', 'important');
            pillList.style.setProperty('overflow-y', 'auto', 'important');
          }, 450);
        }, 100);
      } else {
        // Dropdown closed — remove extra room and scroll back
        if (qvC.dataset.qvDropdownPadding) {
          var trigger = optionGroup.querySelector('.smaak-mobile-dropdown');
          qvClearRoom();
          if (trigger) {
            setTimeout(function() {
              var trigRect = trigger.getBoundingClientRect();
              var containerRect = qvC.getBoundingClientRect();
              if (trigRect.top < containerRect.top) {
                qvC.scrollBy({ top: trigRect.top - containerRect.top - 10, behavior: 'smooth' });
              }
            }, 50);
          }
        }
      }
    });
  });

  observer.observe(document.body, { attributes: true, subtree: true, attributeFilter: ['data-dropdown-open'] });
})();

// 4. CLICK DELEGATION FOR DROPDOWN — only runs once (guarded)
(function() {
  if (window.__smaakDropdownDelegated) return;
  window.__smaakDropdownDelegated = true;

  document.addEventListener('click', function(e) {
    var trigger = e.target.closest('[data-smaak-dropdown-trigger]');
    if (trigger) {
      var dropdown = trigger.closest('[data-smaak-dropdown]');
      if (!dropdown || dropdown.hasAttribute('data-disabled')) return;
      var optionGroup = dropdown.closest('.variant-option-group');
      if (!optionGroup) return;
      var picker = optionGroup.closest('variant-picker');
      if (!picker) return;
      var hasPopup = picker.querySelector('[data-variant-selector-popup]');
      if (hasPopup && window.innerWidth <= 768) return;

      var isOpen = optionGroup.hasAttribute('data-dropdown-open');
      // Close other open dropdowns
      document.querySelectorAll('.variant-option-group[data-dropdown-open]').forEach(function(g) {
        if (g !== optionGroup) {
          g.removeAttribute('data-dropdown-open');
          var pl = g.querySelector('.product-variant-picker__pill-list');
          if (pl) pl.style.cssText = '';
          g.style.position = '';
        }
      });
      if (!isOpen) optionGroup.setAttribute('data-dropdown-open', '');
      else optionGroup.removeAttribute('data-dropdown-open');

      if (!isOpen) {
        var pillList = optionGroup.querySelector('.product-variant-picker__pill-list');
        if (pillList) {
          var triggerEl = optionGroup.querySelector('.smaak-mobile-dropdown');
          var topOffset = triggerEl ? (triggerEl.offsetTop + triggerEl.offsetHeight) : optionGroup.offsetHeight;
          var inQuickView = !!optionGroup.closest('[data-quick-view-content]');
          pillList.style.cssText = 'display:flex!important;position:absolute!important;top:' + topOffset + 'px!important;bottom:auto!important;left:0!important;right:0!important;margin-top:2px;flex-wrap:wrap;gap:8px;padding:12px;background:#fff;border:2px solid rgba(0,0,0,0.1);border-radius:1.2rem;box-shadow:0 4px 12px rgba(0,0,0,0.08);z-index:10;';
          optionGroup.style.position = 'relative';
          var floatEl = optionGroup.querySelector('float-element');
          if (floatEl) floatEl.style.display = 'none';
          // Auto-scroll to show full dropdown in quick view
          if (inQuickView) {
            setTimeout(function() {
              var qvC = optionGroup.closest('[data-quick-view-content]');
              if (qvC) {
                var groupTop = optionGroup.getBoundingClientRect().top;
                var containerTop = qvC.getBoundingClientRect().top;
                var offset = groupTop - containerTop - 10;
                if (offset > 0) {
                  qvC.scrollBy({ top: offset, behavior: 'smooth' });
                }
              }
            }, 50);
          } else if (window.innerWidth <= 768) {
            setTimeout(function() { pillList.scrollIntoView({ behavior: 'smooth', block: 'end' }); }, 50);
          }
        }
      } else {
        var pillList2 = optionGroup.querySelector('.product-variant-picker__pill-list');
        if (pillList2) pillList2.style.cssText = '';
        optionGroup.style.position = '';
        // Scroll back to trigger when closing in quick view
        if (optionGroup.closest('.quick-view__content')) {
          var triggerEl2 = optionGroup.querySelector('.smaak-mobile-dropdown');
          if (triggerEl2) {
            setTimeout(function() { triggerEl2.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); }, 50);
          }
        }
      }
      return;
    }

    // Close dropdowns on outside click (skip if smaakinfo popup is target)
    if (!e.target.closest('.variant-option-group[data-dropdown-open]') && !e.target.closest('#smaakOverlaySheet')) {
      document.querySelectorAll('.variant-option-group[data-dropdown-open]').forEach(function(g) {
        g.removeAttribute('data-dropdown-open');
        var pl = g.querySelector('.product-variant-picker__pill-list');
        if (pl) pl.style.cssText = '';
        g.style.position = '';
      });
    }
  });

  // Update trigger label when smaak pill is clicked in dropdown
  document.addEventListener('click', function(e) {
    var pill = e.target.closest('.variant-option-group:not(.variant-option-group--secondary) .product-variant-picker__pill-list .pill');
    if (!pill) return;
    var optionGroup = pill.closest('.variant-option-group');
    if (!optionGroup) return;
    var label = optionGroup.querySelector('[data-smaak-dropdown-label]');
    var triggerSwatch = optionGroup.querySelector('.smaak-mobile-dropdown__swatch');
    var pillSwatch = pill.querySelector('.pill__swatch');
    if (label) label.textContent = pill.getAttribute('data-option-value');
    if (triggerSwatch && pillSwatch) {
      triggerSwatch.src = pillSwatch.src;
      triggerSwatch.style.display = '';
    }
    optionGroup.removeAttribute('data-dropdown-open');
    var pillList = optionGroup.querySelector('.product-variant-picker__pill-list');
    if (pillList) pillList.style.cssText = '';
    optionGroup.style.position = '';
    // Scroll back when selecting a variant in quick view
    var qvContent = optionGroup.closest('.quick-view__content');
    if (qvContent) {
      var trig = optionGroup.querySelector('.smaak-mobile-dropdown');
      if (trig) setTimeout(function() { trig.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); }, 50);
    }
  });
})();
